


















































import { defineComponent, PropType, ref, watch } from '@nuxtjs/composition-api';
import useBreakpoint from '@shared/composables/useBreakpoint';
import { BaseLink, UCIcon, UCSkeletonShimmer } from '@shared/ui';

import useSteppers from './internal/useSteppers';
import { PartialConfig } from './types';
import VNodes from './VNodes.vue';

export default defineComponent({
  name: 'CardSectionView',
  components: {
    BaseLink,
    VNodes,
    UCIcon,
    UCSkeletonShimmer,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    link: {
      type: [String, Object],
      default: '',
    },
    linkText: {
      type: String,
      default: '',
    },
    showHeader: {
      type: Boolean,
      default: false,
    },
    showHeaderText: {
      type: Boolean,
      default: false,
    },
    showHeaderActions: {
      type: Boolean,
      default: false,
    },
    showDescription: {
      type: Boolean,
      default: false,
    },
    showSteppers: {
      type: Boolean,
      default: false,
    },
    styles: {
      type: Object,
      default: () => ({}),
    },
    mobile: {
      type: Object as PropType<PartialConfig>,
      default: () => ({}),
    },
    tablet: {
      type: Object as PropType<PartialConfig>,
      default: () => ({}),
    },
    desktop: {
      type: Object as PropType<PartialConfig>,
      default: () => ({}),
    },
  },
  setup() {
    const { breakpoint } = useBreakpoint();

    const groupInner = ref<any>(null);
    const { onLeftStep, onRightStep } = useSteppers(groupInner);

    const resetScroll = () => {
      if (groupInner.value) {
        groupInner.value.scrollLeft = 0;
      }
    };

    watch(breakpoint, resetScroll, { immediate: true });

    return {
      groupInner,
      onLeftStep,
      onRightStep,
    };
  },
});
